<template>
  <div class="modal-body lf-modal">
    <div
      v-if="authenticationError"
      class="ent-alert ent-alert--error"
      data-cy="loginError"
      v-html="$t('login.messages.error.authentication')"
    ></div>

    <form role="form" class="lf-form" @submit.prevent="doLogin()">
      <div class="ent-field">
        <label class="ent-label" for="username">{{ $t("global.form['username.label']") }}</label>
        <input
          id="username"
          type="text"
          name="username"
          autofocus
          class="ent-input"
          :placeholder="$t('global.form[\'username.placeholder\']')"
          v-model="login"
          data-cy="username"
        />
      </div>

      <div class="ent-field">
        <label class="ent-label" for="password">{{ $t('login.form.password') }}</label>
        <input
          id="password"
          type="password"
          name="password"
          class="ent-input"
          :placeholder="$t('login.form[\'password.placeholder\']')"
          v-model="password"
          data-cy="password"
        />
      </div>

      <label class="lf-remember" for="rememberMe">
        <input type="checkbox" id="rememberMe" name="rememberMe" v-model="rememberMe" />
        <span>{{ $t('login.form.rememberme') }}</span>
      </label>

      <button data-cy="submit" type="submit" class="ent-btn ent-btn--primary ent-btn-lg lf-submit">{{ $t('login.form.button') }}</button>
    </form>

    <router-link :to="'/account/reset/request'" class="ent-link lf-forgot" data-cy="forgetYourPasswordSelector">{{
      $t('login.password.forgot')
    }}</router-link>
  </div>
</template>

<script lang="ts" src="./login-form.component.ts"></script>

<style scoped>
.lf-modal {
  padding: 1.5rem 1.75rem 1.75rem;
}
.lf-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.lf-form .ent-field {
  margin-bottom: 0;
}
.lf-remember {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 0.9rem;
  color: #333;
  cursor: pointer;
}
.lf-remember input {
  width: 1rem;
  height: 1rem;
  accent-color: #f28a16;
  cursor: pointer;
}
.lf-submit {
  align-self: flex-start;
  margin-top: 0.25rem;
}
.lf-forgot {
  display: inline-block;
  margin-top: 1.25rem;
  font-weight: 600;
}
</style>
